import React from "react";
import "./About.css";
import Banner from "../Banner/Banner";

const About = () => {
  const values = [
    { icon: "💡", title: "Strategic clarity", desc: "Every page and campaign starts with clear business intent." },
    { icon: "⚡", title: "Execution quality", desc: "Fast, reliable builds and disciplined optimization cycles." },
    { icon: "📈", title: "Measurable growth", desc: "Decisions tied to qualified leads, conversion, and revenue." },
  ];

  return (
    <section className="aboutv5">
      <div className="av5-wrap">

        <header>
          <span className="av5-tag">About us</span>
          <h1 className="av5-title">
            We build digital systems that <span>create predictable growth</span>
          </h1>
          <p className="av5-sub">
            We combine strategy, design, development, and marketing execution to
            help businesses grow with confidence.
          </p>
        </header>

        <section className="av5-hero">
          <div className="card">
            <h2 className="av5-h2">What we do</h2>
            <p className="av5-p">
              We design, build, and optimize digital journeys—from positioning and
              UX to lead generation and continuous improvement.
            </p>
            <ul className="av5-list">
              <li>Conversion-ready UX and responsive interfaces</li>
              <li>SEO foundations and content architecture</li>
              <li>Scalable builds with clear handoff and support</li>
            </ul>
          </div>

          <aside className="card">
            <h2 className="av5-h2">Why work with us</h2>
            <ul className="av5-list">
              <li>Transparent planning and regular updates</li>
              <li>Custom strategy based on your funnel</li>
              <li>Performance mindset, not vanity metrics</li>
            </ul>

            <div className="av5-stats">
              <div className="stat"><div className="k">50+</div><div className="d">engagements</div></div>
              <div className="stat"><div className="k">4.9★</div><div className="d">client feedback</div></div>
              <div className="stat"><div className="k">&lt;24h</div><div className="d">support response</div></div>
            </div>
          </aside>
        </section>

        <section className="av5-values">
          {values.map(v => (
            <div className="value" key={v.title}>
              <div>{v.icon}</div>
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
            </div>
          ))}
        </section>

        <section className="av5-cta">
          <div className="card">
            <h2 className="av5-h2">Ready to scale?</h2>
            <p className="av5-p">Share your targets and we will map a clear growth plan.</p>
            <a href="/contact" className="btn btn-primary">Schedule consult</a>
          </div>

          <div className="card">
            <h2 className="av5-h2">Explore capabilities</h2>
            <p className="av5-p">Web, SEO, paid media, and funnel optimization in one team.</p>
            <a href="/services" className="btn btn-outline">See services</a>
          </div>
        </section>

      </div>

      <Banner />
    </section>
  );
};

export default About;
